import React from "react";
import * as strings from "../../strings";
import HeadingOne from "../../components/HeadingOne";

interface Props {
  children: {
    // tableControlsSlot: React.ReactNode;
    tableSlot: React.ReactNode;
    DateRangePicker: React.ReactNode;
    SearchBox: React.ReactNode;
    // audioPlayer: React.ReactNode;
  };
}

export default function CommissionsListPage(props: Props): JSX.Element {
  return (
    <div className="space-y-8">
      <HeadingOne>{strings.COMMISSIONS}</HeadingOne>
      <div className={"ag-theme-alpine isolate h-[600px] pb-14"}>
        <div className="flex flex-col-reverse items-center gap-4 sm:flex-row sm:items-end sm:justify-between">
          {props.children.SearchBox}
          <div className="w-full"></div>
          {props.children.DateRangePicker}
          {/*{props.children.TransactionReportDownload}*/}
        </div>
        {props.children.tableSlot}
      </div>
    </div>
  );
}
